<div class="wrapper">
  <button
    class="feedback-button"
    themeColor="primary"
    aria-label="Share feedback"
    (click)="onFeedbackButtonClick()">
    <span class="k-icon k-font-icon k-i-lightbulb feedback-icon"></span>
  </button>
  <span class="new-badge">NEW</span>
</div>
